import comp from "./ProfilePhotoPickerV2";
export default comp;
